export enum Selection {
  None,
  Selected,
  Offsite,
}



// WEBPACK FOOTER //
// ./src/enums.ts